import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import AuctionPrice from "components/Auction/AuctionPrice"
import Countdown from "components/Countdown"
import {Auction, Subject, Tireset} from "domain-models"
import {make, model} from "filters"
import {useAuctionSettings} from "hooks/StateHooks"
import React from "react"
import {hideAuction} from "redux/actions"
import {store} from "store"
import AuctionType from "../AuctionType"
import WatchButton from "../WatchButton"
import {connect} from "react-redux"
import {GlobalState} from "../../../../state"
import _ from "lodash"
import TireData from "./TireData"
import Protocol from "../VehicleData/Protocol"
import LegalText from "../VehicleData/Details/LegalText"
import IgnoreButton from "../VehicleData/IgnoreButton"
import Description from "../VehicleData/Details/Description"
import Images from "../VehicleData/Details/Images"
import OtherSubjects from "./OtherSubjects"
import Trans from '../../../../components/Trans'

type AuctionDetailsProps = {
  auction: Auction
  close: () => void
  domain: string
}

type State = {
  tireset: Tireset
}

class TiresetDetails extends React.Component<AuctionDetailsProps, State> {
  constructor(props: AuctionDetailsProps) {
    super(props)

    this.state = {
      tireset: _.first(props.auction.subjects)!.tireset as Tireset
    }
  }

  private settings = useAuctionSettings()
  hideAuction = () => {
    store.dispatch(hideAuction())
  }

  render() {
    const {auction} = this.props

    return (
      <div className="w-full h-full flex flex-col">
        <div className="flex flex-row justify-between p-2 shadow">
          <div>
            <button onClick={this.hideAuction}><Icon icon="arrow-left"/> <Trans>Zurück</Trans></button>
          </div>
          <div className="flex justify-end">
            <WatchButton auction={auction}/>
          </div>
        </div>

        <div className={'font-semibold text-xl p-2'}>
          {
            this.state.tireset?.ProductName ?
              <span><Trans>Radsatz</Trans> {this.state.tireset.ProductName}</span>
              :
              <span><Trans>Radsatz für</Trans> {make(this.state.tireset.Make)} {model(this.state.tireset.Make, this.state.tireset.Model)} {this.state.tireset.NFZ ? 'NFZ' : null} </span>
          }

          {this.props.auction.subjects.length > 1 ? <span> + {this.props.auction.subjects.length - 1} <Trans>weitere Artikel</Trans></span> : null}
        </div>

        <div className="w-full h-full overflow-scroll scrollbar p-2">
          <div className="mt-2 flex flex-col lg:flex-row">
            <div className="w-full lg:w-1/2">
              <Images images={this.state.tireset && this.state.tireset.images && this.state.tireset.images.length ? this.state.tireset.images : []}/>

              <AuctionType auctionType={auction.round.Type}/>
            </div>

            <div className="flex flex-col md:hidden">
              <Countdown auction={auction} timeTillDate={auction.round.EndsOn} small={true} hotBid={true}/>

              <AuctionPrice auction={auction} small={true}/>
            </div>

            <div className="lg:ml-4 w-full lg:w-1/2">
              <div className="w-full px-2 whitespace-pre-wrap break-all">
                <TireData tireset={this.state.tireset}/>
              </div>
            </div>
          </div>

          <div className="mt-2 md:hidden">
            <div className="border-t border-gray-300 my-4"/>

            <TireData tireset={this.state.tireset}/>
          </div>

          {
            this.state.tireset.Notes ?
              <>
                <div className="border-t border-gray-300 my-4"/>

                <div className="mt-2">
                  <Description longDescription={this.state.tireset.Notes}/>
                </div>
              </>
              : null
          }

          <div className="border-t border-gray-300 my-4"/>

          {this.props.auction.subjects.length > 1 ?
            <div className="mt-2">
              <OtherSubjects currentTireset={this.state.tireset} tiresets={this.props.auction.subjects.map((subject: Subject) => subject.tireset)}/>
            </div>
            : null}


          <div className="mt-2 md:hidden">
            <div className="border-t border-gray-300 my-4"/>

            {useAuctionSettings().showProtocol ? <Protocol history={auction.history}/> : null}
          </div>

          {
            this.settings.legalNotice ?
              <div className="mt-2">
                <div className="border-t border-gray-300 my-4"/>

                <LegalText/>
              </div>
              : null
          }

          <div className="mt-2 md:hidden">
            <IgnoreButton auction={auction} close={this.props.close}/>
          </div>
        </div>
      </div>
    )
  }
}

export default connect((state: GlobalState) => ({
  domain: state.user.domain
}))(TiresetDetails)
